module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding-d94328ee90891afce6f2ee6fe0d5df04.webp";